import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import { AiChatsQuery, AiChatsRequest } from "lib/generated/app-service-gql/graphql";
import { REACT_QUERY_OPTIONS_NEVER_REFETCH } from "lib/hooks/api/utils";
import { useGraphQlQuery } from "../useGraphQlClient";

const aiChatsQuery = graphql(`
  query aiChats($req: AiChatsRequest!) {
    aiChats(AiChatsRequest: $req) {
      conversationId
      resourceId
      questionAndAnswer {
        question
        answer
        sources {
          id
          type
          title
          url
          chunkNumber
          documentType
          locations {
            pageNumber
            bbox {
              x
              y
              width
              height
            }
          }
        }
      }
    }
  }
`);

export type AiConversation = AiChatsQuery["aiChats"][0];
export type QaContent = AiConversation["questionAndAnswer"][0];

export function useAiChats(
  req: AiChatsRequest,
  options?: UseQueryOptions<AiChatsQuery, unknown, AiChatsQuery, QueryKey>,
) {
  const { data, ...rest } = useGraphQlQuery(["get_ai_chats", req], aiChatsQuery, [{ req }], {
    ...REACT_QUERY_OPTIONS_NEVER_REFETCH,
    ...options,
  });

  return {
    data: data?.aiChats,
    ...rest,
  };
}
